// extracted by css-extract-rspack-plugin
export default {"LabelWithInfo":"oe9tt"};